import { UPDATEAPPROVESTATUS_FAIL, UPDATEAPPROVESTATUS_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const updateApproveStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATEAPPROVESTATUS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATEAPPROVESTATUS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default updateApproveStatusReducer;
